import React from "react";
import PhoneBadge from "./Logos/PhoneBadge";
import { Icon } from "@clarkinc/zest-design-system/ui";
import { cls } from "@wss/cls";

interface PhoneAppProps {
  isPlusEssentials?: boolean;
}

const PhoneApp = ({ isPlusEssentials }: PhoneAppProps) => {
  return (
    <a
      aria-label="get app"
      className={`inline-flex items-center font-semibold text-xs hover:underline no-underline ${
        isPlusEssentials ? "text-white" : "text-gray-800"
      }`}
      data-testid="get-app-ad-global-header"
      href="/services/app/"
    >
      <PhoneBadge />
      Get the App
      <Icon
        className={cls("pl-1 mt-0.5", {
          "fill-['#FFFFFF']": isPlusEssentials,
          "fill-gray-800": !isPlusEssentials,
        })}
        height="12px"
        name="ri-arrow-right-s-line"
        size="2xsmall"
        width="12px"
      />
    </a>
  );
};

export default PhoneApp;
